// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderHistoryList-module__font-s-10___MJ6tG {
  font-size: 10px !important;
}

.OrderHistoryList-module__font-s-12___YEwsg {
  font-size: 12px !important;
}

.OrderHistoryList-module__font-s-13___ovgrs {
  font-size: 13px !important;
}

.OrderHistoryList-module__font-s-14___JDm9D {
  font-size: 14px !important;
}

.OrderHistoryList-module__font-s-15___ZqYvy {
  font-size: 15px !important;
}

.OrderHistoryList-module__font-s-16___iREOG {
  font-size: 16px !important;
}

.OrderHistoryList-module__font-s-18___bPw4l {
  font-size: 18px !important;
}

.OrderHistoryList-module__font-s-20___uzv0T {
  font-size: 20px !important;
}

.OrderHistoryList-module__font-s-22___XlP3m {
  font-size: 22px !important;
}

.OrderHistoryList-module__font-s-28___cPSng {
  font-size: 28px !important;
}

.OrderHistoryList-module__font-w-400___yjgT6 {
  font-weight: 400 !important;
}

.OrderHistoryList-module__font-w-500___qSMbF {
  font-weight: 500 !important;
}

.OrderHistoryList-module__font-w-600___Wq6bI {
  font-weight: 600 !important;
}

.OrderHistoryList-module__font-w-700___cm70v {
  font-weight: 700 !important;
}

.OrderHistoryList-module__p-5___QqYHH {
  padding: 5px !important;
}

.OrderHistoryList-module__p-12___PY5SC {
  padding: 12px !important;
}

.OrderHistoryList-module__p-16___HihZ8 {
  padding: 16px !important;
}

.OrderHistoryList-module__p-30___Ho2oA {
  padding: 30px !important;
}

.OrderHistoryList-module__p-b-0___EglkJ {
  padding-bottom: 0 !important;
}

.OrderHistoryList-module__p-b-5___ebh94 {
  padding-bottom: 5px !important;
}

.OrderHistoryList-module__p-b-10___pGubI {
  padding-bottom: 10px !important;
}

.OrderHistoryList-module__p-b-12___xuWLB {
  padding-bottom: 12px !important;
}

.OrderHistoryList-module__p-b-16___hQMOD {
  padding-bottom: 16px !important;
}

.OrderHistoryList-module__p-b-18___vlYsI {
  padding-bottom: 18px !important;
}

.OrderHistoryList-module__p-b-20___kzaPo {
  padding-bottom: 20px !important;
}

.OrderHistoryList-module__p-b-25___dU11m {
  padding-bottom: 25px !important;
}

.OrderHistoryList-module__p-b-30___XX5Uh {
  padding-bottom: 30px !important;
}

.OrderHistoryList-module__p-b-50___MN3rd {
  padding-bottom: 50px !important;
}

.OrderHistoryList-module__p-t-0___zyoy1 {
  padding-top: 0 !important;
}

.OrderHistoryList-module__p-t-12___UxL7f {
  padding-top: 12px !important;
}

.OrderHistoryList-module__p-t-16___mlXs0 {
  padding-top: 16px !important;
}

.OrderHistoryList-module__p-t-18___xp1Qz {
  padding-top: 18px !important;
}

.OrderHistoryList-module__p-t-20___XdBh4 {
  padding-top: 20px !important;
}

.OrderHistoryList-module__p-t-30___xd3Za {
  padding-top: 30px !important;
}

.OrderHistoryList-module__p-t-40___khyGN {
  padding-top: 40px !important;
}

.OrderHistoryList-module__p-t-50___hyoWe {
  padding-top: 50px !important;
}

.OrderHistoryList-module__p-l-20___vNSQK {
  padding-left: 20px !important;
}

.OrderHistoryList-module__p-l-30___Qdphr {
  padding-left: 30px !important;
}

.OrderHistoryList-module__p-l-40___xNgGp {
  padding-left: 40px !important;
}

.OrderHistoryList-module__p-r-16___Jbv5r {
  padding-right: 16px !important;
}

.OrderHistoryList-module__p-r-20___eRjAR {
  padding-right: 20px !important;
}

.OrderHistoryList-module__p-r-30___WfzsY {
  padding-right: 30px !important;
}

.OrderHistoryList-module__p-r-50___NLrok {
  padding-right: 50px !important;
}

.OrderHistoryList-module__p-r-60___a7T7w {
  padding-right: 60px !important;
}

.OrderHistoryList-module__m-b-1___Il_YP {
  margin-bottom: 1px !important;
}

.OrderHistoryList-module__m-b-2___ImOAN {
  margin-bottom: 2px !important;
}

.OrderHistoryList-module__m-b-6___yBr1D {
  margin-bottom: 6px !important;
}

.OrderHistoryList-module__m-b-8___tH8R1 {
  margin-bottom: 8px !important;
}

.OrderHistoryList-module__m-b-10___rTqsc {
  margin-bottom: 10px !important;
}

.OrderHistoryList-module__m-b-14___zVhIQ {
  margin-bottom: 14px !important;
}

.OrderHistoryList-module__m-b-16___I2hLL {
  margin-bottom: 16px !important;
}

.OrderHistoryList-module__m-b-20___mXv0h {
  margin-bottom: 20px !important;
}

.OrderHistoryList-module__m-b-22___uOt0K {
  margin-bottom: 22px !important;
}

.OrderHistoryList-module__m-b-24___bP8se {
  margin-bottom: 24px !important;
}

.OrderHistoryList-module__m-b-30___NW6UG {
  margin-bottom: 30px !important;
}

.OrderHistoryList-module__m-b-32___mRafT {
  margin-bottom: 32px !important;
}

.OrderHistoryList-module__m-b-40___wTSSq {
  margin-bottom: 40px !important;
}

.OrderHistoryList-module__m-t-2___mJNqx {
  margin-top: 2px !important;
}

.OrderHistoryList-module__m-t-3___ZzoRX {
  margin-top: 3px !important;
}

.OrderHistoryList-module__m-t-4___X_doa {
  margin-top: 4px !important;
}

.OrderHistoryList-module__m-t-5___p8RgA {
  margin-top: 5px !important;
}

.OrderHistoryList-module__m-t-8___bXinS {
  margin-top: 8px !important;
}

.OrderHistoryList-module__m-t-10___Rmuzw {
  margin-top: 10px !important;
}

.OrderHistoryList-module__m-t-15___KJLFy {
  margin-top: 15px !important;
}

.OrderHistoryList-module__m-t-16___e6iEe {
  margin-top: 16px !important;
}

.OrderHistoryList-module__m-t-20___V89JV {
  margin-top: 20px !important;
}

.OrderHistoryList-module__m-t-22___jZ29x {
  margin-top: 22px !important;
}

.OrderHistoryList-module__m-t-30___VCeb4 {
  margin-top: 30px !important;
}

.OrderHistoryList-module__m-t-32___pKtoX {
  margin-top: 32px !important;
}

.OrderHistoryList-module__m-l-auto___o7e1F {
  margin-left: auto !important;
}

.OrderHistoryList-module__m-l-4___kVShk {
  margin-left: 4px !important;
}

.OrderHistoryList-module__m-l-5___N7wWQ {
  margin-left: 5px !important;
}

.OrderHistoryList-module__m-l-6___QLe4z {
  margin-left: 6px !important;
}

.OrderHistoryList-module__m-l-8___Ld3aX {
  margin-left: 8px !important;
}

.OrderHistoryList-module__m-l-10___PLmey {
  margin-left: 10px !important;
}

.OrderHistoryList-module__m-l-16___QsdZU {
  margin-left: 16px !important;
}

.OrderHistoryList-module__m-l-20___xt99a {
  margin-left: 20px !important;
}

.OrderHistoryList-module__m-l-24___Wn2l2 {
  margin-left: 24px !important;
}

.OrderHistoryList-module__m-l-30___MR3W_ {
  margin-left: 30px !important;
}

.OrderHistoryList-module__m-l-35___EbyOb {
  margin-left: 35px !important;
}

.OrderHistoryList-module__m-l-40___zEnrR {
  margin-left: 40px !important;
}

.OrderHistoryList-module__m-r-8___amy65 {
  margin-right: 8px !important;
}

.OrderHistoryList-module__m-r-10____0L9S {
  margin-right: 10px !important;
}

.OrderHistoryList-module__m-r-16___yEKNM {
  margin-right: 16px !important;
}

.OrderHistoryList-module__m-r-20___gbnX1 {
  margin-right: 20px !important;
}

.OrderHistoryList-module__m-r-24____g93H {
  margin-right: 24px !important;
}

.OrderHistoryList-module__m-r-30___eQpgv {
  margin-right: 30px !important;
}

.OrderHistoryList-module__m-r-40___MfWuV {
  margin-right: 40px !important;
}

.OrderHistoryList-module__border-r-3___HCoX6 {
  border-radius: 3px !important;
}

.OrderHistoryList-module__border-r-4___Kopxx {
  border-radius: 4px !important;
}

.OrderHistoryList-module__border-r-6___PbcGG {
  border-radius: 6px !important;
}

.OrderHistoryList-module__border-r-10___BGg9U {
  border-radius: 10px !important;
}

.OrderHistoryList-module__border-r-12___hnrs0 {
  border-radius: 12px !important;
}

.OrderHistoryList-module__border-r-16___n4s9S {
  border-radius: 16px !important;
}

.OrderHistoryList-module__border-r-50___vrXVt {
  border-radius: 50% !important;
}

.OrderHistoryList-module__primary-border___Y0Vwk {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-b___SZP8x {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-t___R2EI1 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-l___NsMOC {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__primary-border-r___wH_NL {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.OrderHistoryList-module__secondary-border___jIY2y {
  border: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-b___hcDQ_ {
  border-bottom: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-t___N_Hge {
  border-top: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-l___uB8PQ {
  border-left: 1px solid #637768;
}

.OrderHistoryList-module__secondary-border-r___apx3a {
  border-right: 1px solid #637768;
}

.OrderHistoryList-module__gap-0___Z1rNE {
  gap: 0 !important;
}

.OrderHistoryList-module__gap-2___eZNJd {
  gap: 2px !important;
}

.OrderHistoryList-module__gap-4___jLUB5 {
  gap: 4px !important;
}

.OrderHistoryList-module__gap-5___XpPKf {
  gap: 5px !important;
}

.OrderHistoryList-module__gap-6___h0pqC {
  gap: 6px !important;
}

.OrderHistoryList-module__gap-8___B6dHR {
  gap: 8px !important;
}

.OrderHistoryList-module__gap-10___aMf6q {
  gap: 10px !important;
}

.OrderHistoryList-module__gap-12___B7BTw {
  gap: 12px !important;
}

.OrderHistoryList-module__gap-14___OzAvp {
  gap: 14px !important;
}

.OrderHistoryList-module__gap-16___ZO4pc {
  gap: 16px !important;
}

.OrderHistoryList-module__gap-18___FSKGn {
  gap: 18px !important;
}

.OrderHistoryList-module__gap-20___x9fWj {
  gap: 20px !important;
}

.OrderHistoryList-module__gap-24___DKht8 {
  gap: 24px !important;
}

.OrderHistoryList-module__gap-26___sOUl0 {
  gap: 26px !important;
}

.OrderHistoryList-module__gap-30___ZHZNl {
  gap: 30px !important;
}

.OrderHistoryList-module__gap-32___P3sP5 {
  gap: 32px !important;
}

.OrderHistoryList-module__gap-40___UJ66f {
  gap: 40px !important;
}

.OrderHistoryList-module__gap-50___bVpTZ {
  gap: 50px !important;
}

.OrderHistoryList-module__flex-1___woKtc {
  flex: 1;
}

.OrderHistoryList-module__flex-none___UzLPH {
  flex: none !important;
}

.OrderHistoryList-module__flex-column___sf9R9 {
  display: flex;
  flex-direction: column !important;
}

.OrderHistoryList-module__flex-row___KHL04 {
  display: flex;
  flex-direction: row !important;
}

.OrderHistoryList-module__vertically-centered___EsE5W {
  display: flex;
  align-items: center !important;
}

.OrderHistoryList-module__horizontally-centered___idrsI {
  display: flex;
  justify-content: center !important;
}

.OrderHistoryList-module__horizontally-end___xyf3q {
  display: flex;
  justify-content: end !important;
}

.OrderHistoryList-module__vertically-start___ZuxgN {
  display: flex;
  align-items: start !important;
}

.OrderHistoryList-module__space-between___hj21z {
  display: flex;
  justify-content: space-between !important;
}

.OrderHistoryList-module__flex-wrap___j7R_G {
  flex-wrap: wrap !important;
}

.OrderHistoryList-module__height-100___CKBTP {
  height: 100%;
}

.OrderHistoryList-module__width-50___UL7Za {
  width: 50% !important;
}

.OrderHistoryList-module__width-100___C0y8t {
  width: 100%;
}

.OrderHistoryList-module__cursor-pointer___OGc5s {
  cursor: pointer;
}

.OrderHistoryList-module__cursor-not-allowed___XTUcH {
  cursor: not-allowed !important;
}

.OrderHistoryList-module__absolute-centered___qXDY4 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.OrderHistoryList-module__absolute___KHnuz {
  position: absolute;
}

.OrderHistoryList-module__relative___EVjEB {
  position: relative;
}

.OrderHistoryList-module__fixed___a8_Sj {
  position: fixed;
}

.OrderHistoryList-module__visible___zQt6a {
  opacity: 1;
}

.OrderHistoryList-module__invisible___bZVi8 {
  opacity: 0;
}

.OrderHistoryList-module__col-90___oB_mc {
  width: 90% !important;
}

.OrderHistoryList-module__col-auto___k2fPg {
  width: auto !important;
}

.OrderHistoryList-module__medical-tabs___h0wr9 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.OrderHistoryList-module__medical-table-new___E0UQo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderHistoryList-module__medical-table-new___E0UQo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderHistoryList-module__medical-table-new___E0UQo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderHistoryList-module__medical-table-new___E0UQo::-webkit-scrollbar-track {
  display: none;
}
.OrderHistoryList-module__medical-table-new___E0UQo.OrderHistoryList-module__no-pagination___vSF18 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.OrderHistoryList-module__medical-table-new___E0UQo.OrderHistoryList-module__no-pagination___vSF18:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.OrderHistoryList-module__medical-table-new___E0UQo.OrderHistoryList-module__no-pagination___vSF18::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.OrderHistoryList-module__medical-table-new___E0UQo.OrderHistoryList-module__no-pagination___vSF18::-webkit-scrollbar-track {
  display: none;
}

.OrderHistoryList-module__medical-table-empty___R0Yju {
  padding: 14px 40px !important;
}

.OrderHistoryList-module__icon-btn___FQB1b {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.OrderHistoryList-module__search-icon___cJV4Z {
  width: 24px;
  height: 24px;
  align-self: center;
}

.OrderHistoryList-module__disable-select___Ri2qO {
  user-select: none;
}

.OrderHistoryList-module__break-word___i2BMT {
  word-break: break-word;
}

.OrderHistoryList-module__popup-clear-btn___zxvxO {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.OrderHistoryList-module__scroll-m-b-20___QJ_N_ {
  scroll-margin-bottom: 20px;
}

.OrderHistoryList-module__empty___Vyee8 {
  padding: 14px 20px;
  background-color: #f1f3e7;
  border-radius: 12px;
  margin: 22px 40px;
}
.OrderHistoryList-module__empty___Vyee8 .OrderHistoryList-module__icon___OWujs {
  width: 22px;
  height: 22px;
}
.OrderHistoryList-module__empty___Vyee8 .OrderHistoryList-module__text___s7AFm {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 19px;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/DevicesFragment/components/OrderHistoryList/OrderHistoryList.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EEaA,+BApBO;EAqBP,gBAFmD;EFVjD,iBAAA;EACA,cAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.empty {\n  padding: 14px 20px;\n  background-color: #f1f3e7;\n  border-radius: 12px;\n  margin: 22px 40px;\n\n  .icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .text {\n    @include get-font($roboto);\n    line-height: 19px;\n    color: get-color(greenNew, dark);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `OrderHistoryList-module__font-s-10___MJ6tG`,
	"fontS12": `OrderHistoryList-module__font-s-12___YEwsg`,
	"fontS13": `OrderHistoryList-module__font-s-13___ovgrs`,
	"fontS14": `OrderHistoryList-module__font-s-14___JDm9D`,
	"fontS15": `OrderHistoryList-module__font-s-15___ZqYvy`,
	"fontS16": `OrderHistoryList-module__font-s-16___iREOG`,
	"fontS18": `OrderHistoryList-module__font-s-18___bPw4l`,
	"fontS20": `OrderHistoryList-module__font-s-20___uzv0T`,
	"fontS22": `OrderHistoryList-module__font-s-22___XlP3m`,
	"fontS28": `OrderHistoryList-module__font-s-28___cPSng`,
	"fontW400": `OrderHistoryList-module__font-w-400___yjgT6`,
	"fontW500": `OrderHistoryList-module__font-w-500___qSMbF`,
	"fontW600": `OrderHistoryList-module__font-w-600___Wq6bI`,
	"fontW700": `OrderHistoryList-module__font-w-700___cm70v`,
	"p5": `OrderHistoryList-module__p-5___QqYHH`,
	"p12": `OrderHistoryList-module__p-12___PY5SC`,
	"p16": `OrderHistoryList-module__p-16___HihZ8`,
	"p30": `OrderHistoryList-module__p-30___Ho2oA`,
	"pB0": `OrderHistoryList-module__p-b-0___EglkJ`,
	"pB5": `OrderHistoryList-module__p-b-5___ebh94`,
	"pB10": `OrderHistoryList-module__p-b-10___pGubI`,
	"pB12": `OrderHistoryList-module__p-b-12___xuWLB`,
	"pB16": `OrderHistoryList-module__p-b-16___hQMOD`,
	"pB18": `OrderHistoryList-module__p-b-18___vlYsI`,
	"pB20": `OrderHistoryList-module__p-b-20___kzaPo`,
	"pB25": `OrderHistoryList-module__p-b-25___dU11m`,
	"pB30": `OrderHistoryList-module__p-b-30___XX5Uh`,
	"pB50": `OrderHistoryList-module__p-b-50___MN3rd`,
	"pT0": `OrderHistoryList-module__p-t-0___zyoy1`,
	"pT12": `OrderHistoryList-module__p-t-12___UxL7f`,
	"pT16": `OrderHistoryList-module__p-t-16___mlXs0`,
	"pT18": `OrderHistoryList-module__p-t-18___xp1Qz`,
	"pT20": `OrderHistoryList-module__p-t-20___XdBh4`,
	"pT30": `OrderHistoryList-module__p-t-30___xd3Za`,
	"pT40": `OrderHistoryList-module__p-t-40___khyGN`,
	"pT50": `OrderHistoryList-module__p-t-50___hyoWe`,
	"pL20": `OrderHistoryList-module__p-l-20___vNSQK`,
	"pL30": `OrderHistoryList-module__p-l-30___Qdphr`,
	"pL40": `OrderHistoryList-module__p-l-40___xNgGp`,
	"pR16": `OrderHistoryList-module__p-r-16___Jbv5r`,
	"pR20": `OrderHistoryList-module__p-r-20___eRjAR`,
	"pR30": `OrderHistoryList-module__p-r-30___WfzsY`,
	"pR50": `OrderHistoryList-module__p-r-50___NLrok`,
	"pR60": `OrderHistoryList-module__p-r-60___a7T7w`,
	"mB1": `OrderHistoryList-module__m-b-1___Il_YP`,
	"mB2": `OrderHistoryList-module__m-b-2___ImOAN`,
	"mB6": `OrderHistoryList-module__m-b-6___yBr1D`,
	"mB8": `OrderHistoryList-module__m-b-8___tH8R1`,
	"mB10": `OrderHistoryList-module__m-b-10___rTqsc`,
	"mB14": `OrderHistoryList-module__m-b-14___zVhIQ`,
	"mB16": `OrderHistoryList-module__m-b-16___I2hLL`,
	"mB20": `OrderHistoryList-module__m-b-20___mXv0h`,
	"mB22": `OrderHistoryList-module__m-b-22___uOt0K`,
	"mB24": `OrderHistoryList-module__m-b-24___bP8se`,
	"mB30": `OrderHistoryList-module__m-b-30___NW6UG`,
	"mB32": `OrderHistoryList-module__m-b-32___mRafT`,
	"mB40": `OrderHistoryList-module__m-b-40___wTSSq`,
	"mT2": `OrderHistoryList-module__m-t-2___mJNqx`,
	"mT3": `OrderHistoryList-module__m-t-3___ZzoRX`,
	"mT4": `OrderHistoryList-module__m-t-4___X_doa`,
	"mT5": `OrderHistoryList-module__m-t-5___p8RgA`,
	"mT8": `OrderHistoryList-module__m-t-8___bXinS`,
	"mT10": `OrderHistoryList-module__m-t-10___Rmuzw`,
	"mT15": `OrderHistoryList-module__m-t-15___KJLFy`,
	"mT16": `OrderHistoryList-module__m-t-16___e6iEe`,
	"mT20": `OrderHistoryList-module__m-t-20___V89JV`,
	"mT22": `OrderHistoryList-module__m-t-22___jZ29x`,
	"mT30": `OrderHistoryList-module__m-t-30___VCeb4`,
	"mT32": `OrderHistoryList-module__m-t-32___pKtoX`,
	"mLAuto": `OrderHistoryList-module__m-l-auto___o7e1F`,
	"mL4": `OrderHistoryList-module__m-l-4___kVShk`,
	"mL5": `OrderHistoryList-module__m-l-5___N7wWQ`,
	"mL6": `OrderHistoryList-module__m-l-6___QLe4z`,
	"mL8": `OrderHistoryList-module__m-l-8___Ld3aX`,
	"mL10": `OrderHistoryList-module__m-l-10___PLmey`,
	"mL16": `OrderHistoryList-module__m-l-16___QsdZU`,
	"mL20": `OrderHistoryList-module__m-l-20___xt99a`,
	"mL24": `OrderHistoryList-module__m-l-24___Wn2l2`,
	"mL30": `OrderHistoryList-module__m-l-30___MR3W_`,
	"mL35": `OrderHistoryList-module__m-l-35___EbyOb`,
	"mL40": `OrderHistoryList-module__m-l-40___zEnrR`,
	"mR8": `OrderHistoryList-module__m-r-8___amy65`,
	"mR10": `OrderHistoryList-module__m-r-10____0L9S`,
	"mR16": `OrderHistoryList-module__m-r-16___yEKNM`,
	"mR20": `OrderHistoryList-module__m-r-20___gbnX1`,
	"mR24": `OrderHistoryList-module__m-r-24____g93H`,
	"mR30": `OrderHistoryList-module__m-r-30___eQpgv`,
	"mR40": `OrderHistoryList-module__m-r-40___MfWuV`,
	"borderR3": `OrderHistoryList-module__border-r-3___HCoX6`,
	"borderR4": `OrderHistoryList-module__border-r-4___Kopxx`,
	"borderR6": `OrderHistoryList-module__border-r-6___PbcGG`,
	"borderR10": `OrderHistoryList-module__border-r-10___BGg9U`,
	"borderR12": `OrderHistoryList-module__border-r-12___hnrs0`,
	"borderR16": `OrderHistoryList-module__border-r-16___n4s9S`,
	"borderR50": `OrderHistoryList-module__border-r-50___vrXVt`,
	"primaryBorder": `OrderHistoryList-module__primary-border___Y0Vwk`,
	"primaryBorderB": `OrderHistoryList-module__primary-border-b___SZP8x`,
	"primaryBorderT": `OrderHistoryList-module__primary-border-t___R2EI1`,
	"primaryBorderL": `OrderHistoryList-module__primary-border-l___NsMOC`,
	"primaryBorderR": `OrderHistoryList-module__primary-border-r___wH_NL`,
	"secondaryBorder": `OrderHistoryList-module__secondary-border___jIY2y`,
	"secondaryBorderB": `OrderHistoryList-module__secondary-border-b___hcDQ_`,
	"secondaryBorderT": `OrderHistoryList-module__secondary-border-t___N_Hge`,
	"secondaryBorderL": `OrderHistoryList-module__secondary-border-l___uB8PQ`,
	"secondaryBorderR": `OrderHistoryList-module__secondary-border-r___apx3a`,
	"gap0": `OrderHistoryList-module__gap-0___Z1rNE`,
	"gap2": `OrderHistoryList-module__gap-2___eZNJd`,
	"gap4": `OrderHistoryList-module__gap-4___jLUB5`,
	"gap5": `OrderHistoryList-module__gap-5___XpPKf`,
	"gap6": `OrderHistoryList-module__gap-6___h0pqC`,
	"gap8": `OrderHistoryList-module__gap-8___B6dHR`,
	"gap10": `OrderHistoryList-module__gap-10___aMf6q`,
	"gap12": `OrderHistoryList-module__gap-12___B7BTw`,
	"gap14": `OrderHistoryList-module__gap-14___OzAvp`,
	"gap16": `OrderHistoryList-module__gap-16___ZO4pc`,
	"gap18": `OrderHistoryList-module__gap-18___FSKGn`,
	"gap20": `OrderHistoryList-module__gap-20___x9fWj`,
	"gap24": `OrderHistoryList-module__gap-24___DKht8`,
	"gap26": `OrderHistoryList-module__gap-26___sOUl0`,
	"gap30": `OrderHistoryList-module__gap-30___ZHZNl`,
	"gap32": `OrderHistoryList-module__gap-32___P3sP5`,
	"gap40": `OrderHistoryList-module__gap-40___UJ66f`,
	"gap50": `OrderHistoryList-module__gap-50___bVpTZ`,
	"flex1": `OrderHistoryList-module__flex-1___woKtc`,
	"flexNone": `OrderHistoryList-module__flex-none___UzLPH`,
	"flexColumn": `OrderHistoryList-module__flex-column___sf9R9`,
	"flexRow": `OrderHistoryList-module__flex-row___KHL04`,
	"verticallyCentered": `OrderHistoryList-module__vertically-centered___EsE5W`,
	"horizontallyCentered": `OrderHistoryList-module__horizontally-centered___idrsI`,
	"horizontallyEnd": `OrderHistoryList-module__horizontally-end___xyf3q`,
	"verticallyStart": `OrderHistoryList-module__vertically-start___ZuxgN`,
	"spaceBetween": `OrderHistoryList-module__space-between___hj21z`,
	"flexWrap": `OrderHistoryList-module__flex-wrap___j7R_G`,
	"height100": `OrderHistoryList-module__height-100___CKBTP`,
	"width50": `OrderHistoryList-module__width-50___UL7Za`,
	"width100": `OrderHistoryList-module__width-100___C0y8t`,
	"cursorPointer": `OrderHistoryList-module__cursor-pointer___OGc5s`,
	"cursorNotAllowed": `OrderHistoryList-module__cursor-not-allowed___XTUcH`,
	"absoluteCentered": `OrderHistoryList-module__absolute-centered___qXDY4`,
	"absolute": `OrderHistoryList-module__absolute___KHnuz`,
	"relative": `OrderHistoryList-module__relative___EVjEB`,
	"fixed": `OrderHistoryList-module__fixed___a8_Sj`,
	"visible": `OrderHistoryList-module__visible___zQt6a`,
	"invisible": `OrderHistoryList-module__invisible___bZVi8`,
	"col90": `OrderHistoryList-module__col-90___oB_mc`,
	"colAuto": `OrderHistoryList-module__col-auto___k2fPg`,
	"medicalTabs": `OrderHistoryList-module__medical-tabs___h0wr9`,
	"medicalTableNew": `OrderHistoryList-module__medical-table-new___E0UQo`,
	"noPagination": `OrderHistoryList-module__no-pagination___vSF18`,
	"medicalTableEmpty": `OrderHistoryList-module__medical-table-empty___R0Yju`,
	"iconBtn": `OrderHistoryList-module__icon-btn___FQB1b`,
	"searchIcon": `OrderHistoryList-module__search-icon___cJV4Z`,
	"disableSelect": `OrderHistoryList-module__disable-select___Ri2qO`,
	"breakWord": `OrderHistoryList-module__break-word___i2BMT`,
	"popupClearBtn": `OrderHistoryList-module__popup-clear-btn___zxvxO`,
	"scrollMB20": `OrderHistoryList-module__scroll-m-b-20___QJ_N_`,
	"empty": `OrderHistoryList-module__empty___Vyee8`,
	"icon": `OrderHistoryList-module__icon___OWujs`,
	"text": `OrderHistoryList-module__text___s7AFm`
};
module.exports = ___CSS_LOADER_EXPORT___;
